import { useMatches } from '@tanstack/react-router';

export const usePageTitle = () => {
  const matches = useMatches();
  const pageTitle = matches.at(-1)?.context?.title;

  return pageTitle;
};
